import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
  phone: "",
};
export const Contact = (props) => {
  const [{ name, email, message, phone }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message, phone);
    
    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }
    
    emailjs
      .sendForm("service_qqcllnv", "template_p6s8yr2", e.target, "3RR2Z6rrHD6uyC4Pk")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-7">
            <div className="row">
              <div className="section-title">
                <h2>Contato</h2>
                <p>
                  Entre em contato conosco que responderemos assim que possível.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="phone-number"
                        name="phone"
                        className="form-control"
                        placeholder="Telefone"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                      </div>
                    </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensagem"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg btn-contact">
                  Enviar Mensagem
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informações para Contato</h3>
              <p>
                <span>
                  <i className="fa fa-user"></i> Rodrigo Costa
                </span>
                {/* {props.data ? props.data.address : "loading"} */}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                    <i className="fa fa-whatsapp"></i> Whatsapp: {" "}
                    <a href="https://api.whatsapp.com/send?phone=19983605031">
                        {props.data ? props.data.phoneRodrigo : "loading"}
                    </a>
                </span>{" "}
                
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email: {""}
                  {props.data ? props.data.email : "loading"}
                </span>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            Rua Octávio Pinhata, 56, Nova Vinhedo - Vinhedo - SP
          </p>
          <p>Desenvolvido por WF - &copy; 2025</p>
        </div>
      </div>
    </div>
  );
};
